export const ADD_INVITE_TABLE_DND_USERS = 'ADD_INVITE_TABLE_DND_USERS';
export const REMOVE_INVITE_TABLE_DND_USERS = 'REMOVE_INVITE_TABLE_DND_USERS';

export const addInviteTableDndUsers = (dndUsers) => {
    return {
        payload: dndUsers,
        type: ADD_INVITE_TABLE_DND_USERS,
    };
};

export const removeInviteTableDndUser = (userId) => {
    return {
        payload: userId,
        type: REMOVE_INVITE_TABLE_DND_USERS,
    };
};
